export const GetFlowNodes = (builder) => ({
    GetFlowNodes: builder.mutation({
        query: ({ id }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: process.env.REACT_APP_CHATBOT_API_PORT + `/chat/getFlowById/${id}`,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token,
                },
            };
        },
    }),
});
